<template>
  <div>
    <b-container class="bv-example-row">
      <b-form @submit="uploadDesignPage">
        <b-form-group id="input-group-1" label="Page name:" label-for="input-1">
          <b-form-input id="input-1" v-model="pageName" type="text" required placeholder></b-form-input>
        </b-form-group>

        <b-button variant="danger" @click="cancelClick">Cancel</b-button>&nbsp;
        <b-button type="submit" variant="primary">Upload</b-button>
      </b-form>
      <br />
    </b-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AddPage",
  props: {
    designID: null,
  },
  data() {
    return {
      pageName: "",
    };
  },
  methods: {
    uploadDesignPage(e) {
      e.preventDefault();

      axios
        .post(
          process.env.VUE_APP_API_SERVER.concat(
            "/v1/designs/",
            this.designID,
            "/pages"
          ),
          { page_name: this.pageName }
        )
        .then((response) => {
          console.log(response.data);
          this.$emit("uploadSuccess", response.data.data);
        })
        .catch((error) => console.log(error))
        .finally(() => (this.loading = false));
    },
    cancelClick() {
      this.$emit("cancelClick");
    },
    mounted() {},
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>